import { t } from "@/i18n-js/instance";
import { classNames } from "@/react/helpers/twMergeWithCN";
import { settingsNavPathV3 } from "@/react/helpers/urlHelpers/settingsNavPathV3";
import { useEventsTracker } from "@/react/hooks/analytics/useEventsTracker";
import { BrandedApp } from "@circle-react-shared/BrandedApp";
import { EmptyState } from "@circle-react-shared/uikit/EmptyState";
import { PricingTabAddPriceModal } from "./AddPriceModal";
import { PricingTabPriceList } from "./PriceList";
import { PricingSettings } from "./PricingSettings";
import { usePricingTabContext } from "./hooks/usePricingTabContext";

export const StripePricingTab = () => {
  const { getPrices, isShowingAddPriceModal, showAddPriceModal } =
    usePricingTabContext();

  const { trackEvent } = useEventsTracker();

  const handleOnClick = () => {
    trackEvent("plus_banner.cta.clicked", {
      origin: "paywalls.stripe_pricing_tab",
    });

    window.open(settingsNavPathV3.plans.brandedApps, "_blank");
  };

  const prices = getPrices();

  return (
    <>
      <div className="flex flex-col gap-y-8">
        {!prices || !prices.length ? (
          <div
            className={classNames(
              "mt-4 flex flex-col items-center justify-center gap-4 rounded-lg border py-20",
            )}
          >
            <EmptyState
              header={t(
                "settings.paywalls.modal.tabs.pricing.empty_state.title",
              )}
              description={t(
                "settings.paywalls.modal.tabs.pricing.empty_state.description",
              )}
              onPrimaryClick={showAddPriceModal}
              primaryLabel={t(
                "settings.paywalls.modal.tabs.pricing.actions.add_price",
              )}
            />
          </div>
        ) : (
          <>
            <PricingTabPriceList />
            <PricingSettings />
          </>
        )}
        <BrandedApp.Banner
          title={t("settings.paywalls.modal.tabs.pricing.branded_apps_title")}
          onClick={handleOnClick}
        />
      </div>
      {isShowingAddPriceModal() && <PricingTabAddPriceModal />}
    </>
  );
};
